<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="input_value = $event"
    :data="sugestedItems"
    :serializer="(item) => item.pessoa_fisica.nome"
    :placeholder="placeholder"
    class="form-control form-control-custom form-bag-select"
    :class="[stateClass]"
    show-all-results
    show-on-focus
    :state="state"
    :size="size"
  >
    <template #suggestion="{ data, htmlText }">
      <span class="mb-2" v-html="htmlText"></span>
      <div class="text-muted">
        <b-badge variant="bagsis" pill>
          {{ formattedManagement(data.mandato) }}
        </b-badge>
      </div>
    </template>
  </VueTypeaheadBootstrap>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";
import moment from "moment";
import { LocalStorage } from "@/helpers/functions/localStorage";
import { slugify } from "@/helpers/functions/slugify";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    return_object: false,
    placeholder: {
      type: String,
      default: "Selecione um Conselheiro",
    },
    mandato_id: {
      type: Number,
      default: null,
    },
    mandato_tipo: {
      type: String,
      default: "conselheiro",
    },
    mandato_ini: {
      type: String,
    },
    mandato_fim: {
      type: String,
    },
    conselhoId: {
      type: Number,
      default: -1,
    },
    not_show: {
      type: Number,
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    itens: [],
  }),
  computed: {
    conselheiros() {
      const mandatoIni = moment(this.mandato_ini);
      const mandatoFim = moment(this.mandato_fim);

      let response = this.mandato_id
        ? _.filter(this.itens, (o) => {
            if (this.mandato_tipo == "conselheiro") {
              return o.mandato_id == this.mandato_id;
            } else {
              const mandatoConselheiroIni = moment(o.mandato.gestao_ini);
              const mandatoConselheiroFim = moment(o.mandato.gestao_fim);

              return (
                mandatoConselheiroIni.isBetween(
                  mandatoIni,
                  mandatoFim,
                  undefined,
                  "[]"
                ) ||
                mandatoConselheiroFim.isBetween(
                  mandatoIni,
                  mandatoFim,
                  undefined,
                  "[]"
                )
              );
            }
          })
        : this.itens;

      if (this.not_show) {
        response = _.filter(response, (o) => {
          return o.pessoa_fisica_id != this.not_show;
        });
      }

      return response;
    },
    sugestedItems() {
      const allItems = this.conselheiros;
      const matchCase = slugify(this.search);
      const re = new RegExp(matchCase, "gi");

      const defaultValue = { pessoa_fisica: {} };

      const matcheValue = (item) => slugify(item.pessoa_fisica.nome).match(re);
      const filterByNameCaseSensitive = (item = defaultValue) =>
        matcheValue(item) !== null;

      return allItems.filter(filterByNameCaseSensitive);
    },
  },
  methods: {
    ...mapActions("conselheiros", ["ActionFind"]),
    setById(id) {
      let selected = _.find(this.itens, { id: id });
      if (selected) {
        this.search = selected.pessoa_fisica.nome;
        this.input_value = selected;
      }
    },
    formattedManagement(mandato) {
      const getYear = (date) => moment(date).year();
      const startDate = getYear(mandato.gestao_ini);
      const endDate = getYear(mandato.gestao_fim);
      return `${startDate} - ${endDate}`;
    },
    async isValid() {
      let valid = true;

      if (this.mandato_id && this.mandato_id != this.input_value.mandato_id) {
        valid = false;
      }
      return valid;
    },
    async verifyConselhoId() {
      const validId = this.conselhoId > -1 ? this.conselhoId : "";
      const formatedKey = `@conselhos/conselheiros/${validId}`;

      const conselheirosStored = LocalStorage(formatedKey);
      const hasItems = (conselheirosStored.getItem || []).length > 0;

      if (!(conselheirosStored.has && hasItems)) {
        const params = {
          per_page: 1000,
          conselho_id: validId ? this.conselhoId : undefined,
        };
        const itens = await this.ActionFind(params);
        conselheirosStored.store(itens.data);
      }

      this.itens = conselheirosStored.getItem;
      if (this.value) {
        this.setById(this.value);
      }
    },
  },
  watch: {
    conselhoId: function (value) {
      this.verifyConselhoId();
    },
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.id);
      }
    },
  },
  async created() {
    await this.verifyConselhoId();
  },
};
</script>
